export interface BreadcrumbNode {
    name: string;
    route: string;
}

export class Breadcrumb {
    routeName: string = '';
    /** Ancestors in display order, nearest the root first; empty for top-level screens. */
    parents: BreadcrumbNode[] = [];

    constructor() {}
}
